export const blockIconsCommonactionsPendingNew = (
	<span className='material-symbols-outlined'>pending</span>
);
